// config
import * as http from 'utils/http';
import config from 'config';
// utils

const markAlertsAsRead = async (ids) => {
  const data = await http.patch(`${config.API_URL}price-negotiation/alerts/mark-as-read/`, {
    ids,
  });
  return data;
};

export default markAlertsAsRead;
